import React from 'react';
import { Button, Modal } from 'react-bootstrap';

const ModalReprocessar = ({ show, onConfirm, onCancel, loading }) => (
  <Modal show={show} onHide={onCancel} centered>
    <Modal.Header closeButton>
      <Modal.Title>Arquivo já processado</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      Já existe processamento deste arquivo nas últimas 24h. Deseja reprocessar mesmo assim?
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={onCancel} disabled={loading}>
        Cancelar
      </Button>
      <Button variant="warning" onClick={onConfirm} disabled={loading}>
        {loading ? 'Processando...' : 'Confirmar Reprocessamento'}
      </Button>
    </Modal.Footer>
  </Modal>
);

export default ModalReprocessar;
